/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import Select from 'react-select';

import { IEcommLiveStreamViewProps } from './ecomm-live-stream';

/**
 *
 * EcommContentTemplate1View component
 * @extends {React.PureComponent<IEcommLiveStreamViewProps>}
 */
export class EcommLiveStreamView extends React.PureComponent<IEcommLiveStreamViewProps> {
    public state: any = {
        currFloor: 0,
        volume: 1,
        isMuted: true,
        floors: [],
        loaded: false,
        hasMounted: false
    };

    public componentDidMount(): void {
        if (!this.state.hasMounted) {
            this.setState({ hasMounted: true });
        }
    }

    public render(): JSX.Element | null {
        if (!this.state.hasMounted) {
            return null;
        }

        const { streams, anchorID, mobileMode } = this.props;

        if (mobileMode) {
            return null;
        }

        const floorSelector: { value: number; label: string }[] = [];

        if (streams && this.state.floors.length === 0) {
            streams.map((item, index) => floorSelector.push({ value: index, label: item.streamName }));

            this.setState(() => {
                return {
                    currFloor: 0,
                    volume: 1,
                    isMuted: false,
                    floors: floorSelector
                };
            });
        }

        if (anchorID && anchorID !== '') {
            return (
                <div className='anchor' id={anchorID ? anchorID : ''}>
                    {streams && streams[this.state.currFloor] && this._renderDesktop()}
                </div>
            );
        }

        return <div>{streams && streams[this.state.currFloor] && this._renderDesktop()}</div>;
    }

    private _renderDesktop(): JSX.Element | null {
        const { config, title, floorPrompt, streams } = this.props;

        const showFloors = streams && streams.length > 1;
        const oneFloorOnly =
            streams && streams.length > 1 ? null : (
                <div className='floor-display'>
                    <span>{floorPrompt}</span>
                    <span>{streams[0].streamName}</span>
                </div>
            );

        return (
            <div className='ecomm-live-stream'>
                <div className='ecomm-live-stream-header row'>
                    <div className='col-sm-7'>
                        <div className='ecomm-live-stream-floors row'>
                            <h4 className='ecomm-live-stream-title'>{title}</h4>
                            <span className='divider' />
                            {oneFloorOnly}
                            {showFloors && <p className=''>{floorPrompt}</p>}
                            {this._renderFloorSelect()}
                        </div>
                    </div>
                    <h4 className='sutra-prompt col-sm-5'>{config.schedulePrompt}</h4>
                </div>
                <div className='ecomm-live-stream-content row'>
                    <div className='ecomm-live-stream-video col-sm-7'>
                        {/* {this.state.loaded ? null : <div className='loader-wrapper'><Loader/></div>} */}
                        {this._renderPlayer()}
                    </div>
                    {this._renderSchedule()}
                </div>
            </div>
        );
    }

    private _renderFloorSelect(): JSX.Element | null {
        const { streams } = this.props;

        if (!(streams && streams.length > 1)) {
            return null;
        }

        return (
            <Select
                className='floor-selector col-sm-2'
                placeholder={streams[this.state.currFloor].streamName}
                options={this.state.floors}
                onChange={this._setFloor}
            />
        );
    }

    private _renderPlayer(): JSX.Element | null {
        const { streams } = this.props;

        // const canPlay = ReactPlayer.canPlay(streams[this.state.currFloor].streamUrl) ? true : false;

        return (
            <div id='player-wrapper' className='player-wrapper'>
                <iframe
                    className='player'
                    src={`${streams[this.state.currFloor].streamUrl}embed`}
                    width='640'
                    height='360'
                    frameBorder='0'
                    allow='autoplay; fullscreen'
                    allowFullScreen
                    scrolling='no'
                ></iframe>
            </div>
        );
    }

    private _renderSchedule(): JSX.Element | null {
        const { events, noScheduleFeedback } = this.props;

        if (events === null) {
            return (
                <div className='ecomm-live-stream-sutras col-sm-5'>
                    <h3 className='no-schedule'>{noScheduleFeedback}</h3>
                </div>
            );
        }

        return (
            <div className='ecomm-live-stream-sutras col-sm-5'>
                {events && events.map((event, index) => <div key={index}>{event}</div>)}
            </div>
        );
    }

    private _setFloor = (event: any) => {
        this.setState({
            currFloor: event.value,
            loaded: false,
            player: 'player no-visible'
        });
    };

    // private _setLoaded = () => {
    //   this.setState({ loaded: true });
    // }

    // private _renderControls(): JSX.Element | null {
    //   const muteStyle = this.state.isMuted ? 'mute' : 'unmute';

    //   return (
    //     <div className='ecomm-live-stream-controls row'>
    //       <div className='ecomm-live-stream-controls-player col-6'>
    //         <button className={muteStyle} onClick={this._setMuted}/>
    //         <input
    //           className='slider'
    //           type='range'
    //           min='0'
    //           max='1'
    //           step='any'
    //           id='volume-slider'
    //           onInput={this._setVolume}
    //         />
    //       </div>
    //       <div className='ecomm-live-stream-controls-view col-6'>
    //         <button className='fullscreen' onClick={this._setFullscreen}/>
    //       </div>
    //     </div>
    //   );
    // }

    // private _setMuted = () => {
    //   this.setState(() => { return { isMuted: !this.state.isMuted }; });
    // }

    // private _setVolume = () => {
    //   this.setState(() => { return { isMuted: false, volume: Number((document.getElementById('volume-slider') as HTMLInputElement).value) }; });
    // }

    // private _setFullscreen = () => {
    //   (document.getElementById('player-wrapper') as HTMLInputElement).requestFullscreen();
    // }
}

export default EcommLiveStreamView;
